export default __webpack_public_path__ + "static/media/09.d4ed84a3.jpg";